import { Suspense, React } from 'react';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom'
// import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import LoginContainer from './LoginContainer';
import AdminContainer from './AdminContainer';
import WebCheckout from "./WebCheckout";
import SelectPlan from "./signup/SelectPlan";
import PurchaseConfirm from './PurchaseConfirm';
import PurchaseCanceled from './PurchaseCanceled';

function App() {
  return (
    <Suspense fallback={<div></div>}>
      <Router>
        <Switch>
          <Route exact path="/" render={ () =>
            <Redirect to={{ pathname:"/login"}}/>
          }/>
          <Route path={["/verify/:token", "/console"]} component={AdminContainer} />
          <Route path={["/login", "/register"]} component={LoginContainer} />
          <Route path={["/purchaseConfirm", "/purchaseConfirm"]} component={PurchaseConfirm} />
          <Route path={["/purchaseCanceled", "/purchaseCanceled"]} component={PurchaseCanceled} />
          <Route path={["/signup"]} component={WebCheckout} />
        </Switch>
      </Router>
    </Suspense>
  );
}

export default App;
